import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router';
import { usePageContext } from '@hero/web-context';
import { useCurrentUser } from '@hero/hooks-shared';
import {
  OrganizationProfileManager,
  PageBack,
  useCarrierProfileTabIds,
  type CarrierProfileTabId,
} from '@hero/web-components';

export default function Profile() {
  const { t } = useTranslation(['applications']);
  const { setPageName } = usePageContext();
  const { org } = useCurrentUser();
  // URL-driven tab so deep-links (e.g. financing's "complete your
  // banking" CTA) can land directly on the right section. We
  // round-trip via `?tab=banking` instead of route segments to
  // keep the typed-nav surface free of per-tab routes.
  const [params, setParams] = useSearchParams();
  const validTabs = useCarrierProfileTabIds();
  const rawTab = params.get('tab');
  const activeTab: CarrierProfileTabId =
    rawTab && (validTabs as readonly string[]).includes(rawTab)
      ? (rawTab as CarrierProfileTabId)
      : 'general';

  useEffect(() => {
    setPageName(t('applications:Profile.title'));
  }, [setPageName, t]);

  if (!org?._id) return null;

  return (
    <div className={activeTab === 'waybill' ? 'max-w-6xl mx-auto mt-6' : 'max-w-3xl mx-auto mt-6'}>
      <PageBack redirect />
      <OrganizationProfileManager
        variant="carrier"
        activeTab={activeTab}
        onTabChange={tab => {
          const next = new URLSearchParams(params);
          next.set('tab', tab);
          setParams(next, { replace: true });
        }}
      />
    </div>
  );
}
